import React from 'react';
import Event from '../../model/Event';

import { Card, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import parse from 'url-parse';
import './EventView.css';
import { matchPath } from 'react-router';
import EventStatusIcon from '../icons/EventStatusIcon';
import AccreditationIcon from '../icons/AccreditationIcon';
import DNSSECAccreditationIcon from '../icons/DNSSECAccreditationIcon';
import { Item } from '../Views/Item';
import IconPlus from '../icons/IconPlus';
import IconMinus from '../icons/IconMinus';
import { useTranslation } from '@nic-react-i18n/core';

// import { rootAPI } from '../../constants/globals';

interface EventViewProps {
    event: Event;
    simple?: boolean;
}

type EventPropsType = EventViewProps

const linkIcon: Record<string, any> = {
    'booking': (event: Event) => {
        return <span><i className={'fal fa-calendar-alt'}/> </span>;
    },
    'request': (event: Event) => {
        return (event.type === 'registrar' ?
            <AccreditationIcon size={'1.55rem'} color={'orange'}/> :
            <DNSSECAccreditationIcon size={'1.55rem'}/>);
    },
};
/*
const testTypeIcon: Record<string, string> = {
    'registrar': 'fa-lock-open'
};
*/
const enabledLinks: Record<string, boolean> = {
    'request': true,
    'booking': false,
};

const patternLinks: Record<string, string> = {
    request: `/requests/:id`,
    booking: `/bookings/:id`,
};

const urlPrologue: Record<string, string> = {
    request: '/requests',
    booking: '',
};

const REQUEST = 'request';

const EventView: React.FC< EventPropsType>  = (props) => {
    const [expand, setExpand] = React.useState(false)
    const {t} = useTranslation()
    const renderResultStatus = (event: Event, key: number): Array<React.ReactElement<any>> => {
       // let iconClass = icon[event.status];
        return (
          [
              (
                  <Tooltip title={t( `status.${event.status}`)}>
                      <span style={{fontSize: '1.2rem'}}>
                          <EventStatusIcon status={event.status}/>
                      </span>
                  </Tooltip>
              )
          ]
        );
    }
/*
    const renderTestInfo = (event: Event, key: number): Array<React.ReactElement<any>> => {
        return (
            [
                (
                    <Tooltip key={key} title={t('test.version', {version: event.version})}>
                        <div>
                            <i className={`fal ${testTypeIcon[event.type]}`}/>
                            <span style={{paddingLeft: '5px', fontSize: '9pt'}}>{event.version}</span>
                        </div>
                    </Tooltip>
                )
            ]
        );
    }
*/
    const renderActions = (event: Event): Array<React.ReactElement<any>> => {
        let links = event.links as any;
        // console.log('EventView Links :', links);
        let linkArray = [];
        if (links) {
            for (let key in links) {
                if (key) {

           //         console.log('EventView links: link', links[key], key);
                    if (enabledLinks[key]) {
                        const url = parse(links[key].href);
                        let match = matchPath( patternLinks[key], url.pathname);

                        let idStr = 'id';
                        if (match && match.params) {
                            let id = match.params[idStr];

                            let toUrl = `${urlPrologue[key]}?${key}=${id}`;

                            linkArray.push(
                                <Tooltip key={key} title={t(`link.${key}`)}>
                                    <span>
                                        <Link to={toUrl} type={key}>
                                            {linkIcon[key](event)}
                                        </Link>
                                    </span>
                                </Tooltip>
                            );
                        }
                    }
                }
            }
        }
        return linkArray;
    }
/*
    const renderItemEvent = (label: string, value: string) => {
        return (
            <div className={'event-card-detail-item'}>
                <Col lg={4} >
                    <span className={'event-card-detail-label'}>{label}:</span>
                </Col>
                <Col className={'event-card-detail'} lg={20}>{value}</Col>
            </div>
        );
    }
*/
    const getRequestUrl = (event: Event): string => {
        let links = event.links;

       //console.log('getRequestUrl: ', links);

        let toUrl = '#';
        if (links) {
            let url = parse(links[REQUEST].href);
            // console.log('PARSE: ', url);
            let match = matchPath(patternLinks[REQUEST], url.pathname);

            let idStr = 'id';
            // console.log('getRequestUrl MAtch: ', patternLinks[REQUEST], url, match);

            if (match && match.params) {
                let id = match.params[idStr];

                toUrl = `${urlPrologue[REQUEST]}/${id}`;
            }
        }
        return toUrl;
    }

    const renderFullEvent = (event: Event): React.ReactElement<any> => {


        let toUrl = getRequestUrl(event);

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                }}
            >
                 <span className={'registrar-link'}>
                     <div className={'event-card-detail-first'}>
                        <Link to={toUrl} type={REQUEST}>
                            {event.registrar}
                         </Link>
                     </div>
                 </span>
                <div>
                    <Item
                        style={{textTransform: 'none'}}
                        label={t('event.server')}
                        value={event.server}
                    />
                </div>
                <div>
                <Item
                    label={t('event.status')}
                    value={t(`requests.filter.${event.status}`)}
                />
                </div>
                <div>
                    <Item label={t( 'event.type')} value={event.type}/>
                </div>
                <div>
                    <Item label={t('event.version')} value={event.version}/>
                </div>
            </div>
        );
    }


        const {event, simple} = props;

        const isSimple: boolean = (simple ?? false);
        const linkClass = (isSimple ? '-simple' : '');

        let extraComponent =   !isSimple ? (
            <div
                style={{
                    cursor: 'pointer'
                }}
                onClick={() => {
                    setExpand(!expand)
                }}
            >
                {expand ? <IconMinus/> : <IconPlus/>}
            </div>
        ) : (null);

        return (
            <div style={{marginBottom: '5px'}}>
                        <Card
                            style={{minWidth: '200px'}}
                            className={'event-card'}
                            actions={renderResultStatus(event, 0).concat(
                                    renderActions(event))}
                            extra={extraComponent}
                        >
                            <div className={'cardTitle'}>
                                {!expand &&
                                    <span className={`registrar-link${linkClass}`}>
                                        <Link to={getRequestUrl(event)}>{event.registrar}</Link>
                                    </span>
                                }
                                {expand && renderFullEvent(event)}

                            </div>
                        </Card>
            </div>
        );

}
export default EventView
